// services/purchaseOrderService.js
import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const purchaseOrderService = {
  // Get all purchase orders with pagination
  getAllPurchaseOrders: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.PURCHASE_ORDERS}`, { 
        params: {
          page: params.page || 1,
          per_page: params.per_page || 15,
          ...params
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get purchase order by ID
  getPurchaseOrderById: async (orderId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.PURCHASE_ORDER_BY_ID(orderId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new purchase order
  createPurchaseOrder: async (orderData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.PURCHASE_ORDERS}`, orderData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update purchase order
  updatePurchaseOrder: async (orderId, orderData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.PURCHASE_ORDER_BY_ID(orderId)}`, orderData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update purchase order delivery
  updateDelivery: async (orderId, deliveryData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.PURCHASE_ORDER_UPDATE_DELIVERY(orderId)}`, deliveryData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete purchase order
  deletePurchaseOrder: async (orderId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}${API_URLS.PURCHASE_ORDER_BY_ID(orderId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Mark as ordered
  markAsOrdered: async (orderId) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.PURCHASE_ORDER_MARK_ORDERED(orderId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Mark as delivered
  markAsDelivered: async (orderId) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.PURCHASE_ORDER_MARK_DELIVERED(orderId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get purchase orders by supplier
  getPurchaseOrdersBySupplier: async (supplierId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.SUPPLIER_PURCHASE_ORDERS(supplierId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get draft purchase orders
  getDraftPurchaseOrders: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.DRAFT_PURCHASE_ORDERS}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default purchaseOrderService;